import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Silently exchanges the Emergent OAuth session_id (in the URL fragment) for our
// own session cookie, then redirects into the app.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { authenticate } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");

    // Clear the fragment so the token is never left in history / re-processed.
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } },
        );
        authenticate(data.user);
        navigate(data.user.onboarded ? "/begin" : "/onboarding", { replace: true });
      } catch (err) {
        toast(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        navigate("/auth", { replace: true });
      }
    })();
  }, [authenticate, navigate]);

  return (
    <div
      data-testid="auth-callback-screen"
      className="min-h-screen flex items-center justify-center"
    >
      <span className="thinking-dot text-[var(--mirror-text-3)] text-sm tracking-[0.3em] uppercase">
        mirror
      </span>
    </div>
  );
}
